import Vue from "vue";

import ApiDuodraw from "./modules/ApiDuodraw";

Vue.prototype.$http = {
    ...ApiDuodraw,
};
